// extracted by mini-css-extract-plugin
module.exports = {"container":"price-movement-chart_container__2ocRo","loader":"price-movement-chart_loader__1JZ6_"};